import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
import InvoiceSettingsTab from "./InvoiceSettingsTab";

function InvoiceSettings() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Invoice Settings</h1>
            {/* <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={() => navigate("/CreateInvoice")}
            >
              Create New Invoice
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="InvoicePreviewMain invoiceSettingMain">
              <div className="InvoicePreviewInnerMain">
                <div className="userContMain">
                  <InvoiceSettingsTab />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default InvoiceSettings;
